"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _elementUi = _interopRequireDefault(require("element-ui"));
var _ptBr = _interopRequireDefault(require("element-ui/lib/locale/lang/pt-br"));
var _globalDirectives = _interopRequireDefault(require("./globalDirectives"));
var _globalMixins = _interopRequireDefault(require("./globalMixins"));
var _globalComponents = _interopRequireDefault(require("./globalComponents"));
var _vueLazyload = _interopRequireDefault(require("vue-lazyload"));
var _vuelidate = _interopRequireDefault(require("vuelidate"));
var _buefy = _interopRequireDefault(require("buefy"));
require("buefy/dist/buefy.css");
var _vueTheMask = _interopRequireDefault(require("vue-the-mask"));
require("eva-icons/style/scss/eva-icons.scss");
var _vMask = _interopRequireDefault(require("v-mask"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  install: function install(Vue) {
    Vue.use(_elementUi.default, {
      locale: _ptBr.default,
      size: _jsCookie.default.get('size') || 'medium'
    });
    Vue.use(_globalDirectives.default);
    Vue.use(_globalMixins.default);
    Vue.use(_globalComponents.default);
    Vue.use(_buefy.default);
    Vue.use(_vuelidate.default);
    Vue.use(_vueTheMask.default);
    Vue.use(_vMask.default);
    Vue.use(_vueLazyload.default, {
      observer: true,
      // optional
      observerOptions: {
        rootMargin: '0px',
        threshold: 0.1
      }
    });
  }
};